import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  Group,
  NumberFormatter,
  NumberInput,
  Paper,
  Stack,
  Text,
  Title,
  useComputedColorScheme,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { checkoutCredits } from "../api";
import { track } from "../analytics/mixpanel";
import Faq from "./Faq";

function checkout(plan, callback) {
  checkoutCredits(plan)
    .then((data) => {
      try {
        track("Checkout credits");
      } catch (e) {
        console.warn("mixpanel.track failed", e);
      }
      if (callback) callback();
      location.href = data.redirectUrl;
    })
    .catch((error) => {
      alert(i18n.t("payment.credits.checkoutError", { error }));
      if (callback) callback();
    });
}

function PlanBox({ plan, highlight, interval, style }) {
  return null; // No longer used
}

export const CreditsPricingPage = () => {
  const { t } = useTranslation("common");
  const [amount, setAmount] = useState(100);
  const [isLoading, setIsLoading] = useState(false);

  // Round (not floor): the backend charges in whole cents — round(credits * 0.3) in
  // StripeCheckoutController — so flooring would hand the user fewer credits for the same charge.
  const credits = Math.round(amount / 0.003);
  const minAmount = 10;
  const maxAmount = 5000;

  const handleCheckout = () => {
    setIsLoading(true);
    checkout({ items: [{ id: "credit", quantity: credits }] }, () =>
      setIsLoading(false)
    );
  };

  return (
    <Container size="lg">
      <Stack gap={40} mt="md" mb="xl" pt="md" pb="xl">
        <a id="start" />
        <Flex
          direction="column"
          gap={10}
          align="center"
          justify="start"
          mb="xl"
        >
          <Title>{t("payment.credits.title")}</Title>
          <Text size="lg" ta="center" fw={500}>
            {t("payment.credits.subtitle")}
          </Text>
        </Flex>

        <Paper
          withBorder
          p="xl"
          radius="md"
          style={{ maxWidth: 500, margin: "0 auto", width: "100%" }}
        >
          <Stack gap="xl">
            <Stack gap="xs">
              <Text fw={600} size="sm">
                {t("payment.credits.quickSelect")}
              </Text>
              <Group grow>
                <Button variant="outline" onClick={() => setAmount(20)}>
                  $20
                </Button>
                <Button variant="outline" onClick={() => setAmount(100)}>
                  $100
                </Button>
                <Button variant="outline" onClick={() => setAmount(500)}>
                  $500
                </Button>
              </Group>
            </Stack>

            <NumberInput
              label={t("payment.credits.customAmountLabel")}
              description={t("payment.credits.customAmountDescription")}
              value={amount}
              onChange={(val) => setAmount(Number(val))}
              min={minAmount}
              max={maxAmount}
              step={10}
              thousandSeparator=","
              prefix="$"
              size="lg"
            />

            <Divider />

            <Box ta="center">
              <Text size="sm" c="dimmed" fw={500} mb={5}>
                {t("payment.credits.youWillReceive")}
              </Text>
              <Title order={2} c="indigo">
                <NumberFormatter value={credits} thousandSeparator />{" "}
                {t("payment.credits.creditsLabel")}
              </Title>
              <Text size="xs" c="dimmed" mt={5}>
                {t("payment.credits.rate")}
              </Text>
            </Box>

            <Button
              loading={isLoading}
              color="indigo"
              size="xl"
              onClick={handleCheckout}
              disabled={amount < minAmount}
              fullWidth
            >
              {t("payment.credits.buyButton")}
            </Button>
          </Stack>
        </Paper>

        <Paper mt="xl" ta="center">
          <Text c="dimmed">{t("payment.credits.deliveryNote")}</Text>
        </Paper>
        <Paper mt="lg" ta="center">
          <Text c="dimmed">{t("payment.credits.pricesSubjectToChange")}</Text>
        </Paper>
      </Stack>
      <Faq />
    </Container>
  );
};
